{
  "debugLogin": {
    "number": "Dev-пользователь №",
    "signIn": "Dev-вход",
    "signingIn": "Вход…",
    "failed": "Не удалось войти (HTTP {{status}}). Проверьте, что API использует ENV=dev.",
    "networkError": "Нет связи с локальным API."
  },
  "common": {
    "retry": "Повторить",
    "loadFailed": "Не удалось загрузить. Попробуйте ещё раз.",
    "loading": "Загрузка…",
    "close": "Закрыть",
    "dismiss": "Скрыть",
    "you": "вы",
    "youCap": "Вы",
    "cancel": "Отмена",
    "showPassword": "Показать пароль",
    "hidePassword": "Скрыть пароль"
  },
  "nav": {
    "main": "Главное меню",
    "skip": "Перейти к содержимому",
    "games": "Игры",
    "packages": "Паки",
    "profile": "Профиль и настройки",
    "signIn": "Войти",
    "admin": "Админка",
    "leaderboard": "Рейтинг"
  },
  "notFound": {
    "title": "Такой страницы нет"
  },
  "roles": {
    "showman": "Ведущий",
    "player": "Игрок",
    "spectator": "Зритель"
  },
  "login": {
    "title": "Выберите имя и играйте",
    "subtitle": "Аккаунт не нужен. Другие игроки увидят ваше имя.",
    "nameLabel": "Ваше имя",
    "namePlaceholder": "например, Мира",
    "nameHelp": "1–50 символов. Изменить можно позже в настройках.",
    "nameRequired": "Сначала введите имя.",
    "continueGuest": "Продолжить как гость",
    "signingIn": "Входим…",
    "discordHelp": "Есть Discord? Войдите, чтобы ваши паки и имя были на всех устройствах.",
    "discord": "Войти через Discord",
    "discordFailed": "Вход через Discord не завершился. Попробуйте ещё раз или продолжите как гость."
  },
  "home": {
    "inProgress": "Игра идёт",
    "stillIn": "Вы всё ещё в игре «{{title}}»",
    "stillInLobby": "Лобби ждёт. Ваше место сохранено.",
    "stillInPlaying": "Игра идёт. Ваше место и счёт сохранены.",
    "rejoin": "Вернуться",
    "joinTitle": "Подключайтесь к игре за секунды",
    "joinSubtitle": "Вставьте ссылку-приглашение или код комнаты. Вы попадёте в лобби, где вас ждёт место.",
    "codeLabel": "Код комнаты или ссылка",
    "codeInvalid": "Это не похоже на код комнаты или ссылку на игру.",
    "join": "Присоединиться",
    "watch": "Смотреть",
    "hostTitle": "Проведите свою игру",
    "hostSubtitle": "Выберите пак, настройте комнату, поделитесь ссылкой. Вы — ведущий.",
    "createGame": "Создать игру",
    "openGames": "Открытые игры",
    "search": "Поиск игр",
    "clearSearch": "Очистить поиск",
    "noMatches": "Нет игр по вашему поиску и фильтрам.",
    "filter": "Фильтр игр",
    "filters": {
      "all": "Все",
      "lobby": "В лобби",
      "playing": "Идут"
    },
    "status": {
      "lobby": "В лобби",
      "playing": "Идут"
    },
    "private": "Пароль",
    "package": "Пак · {{title}}",
    "players": "игроков",
    "host": "Ведущий {{name}}",
    "noGames": "Сейчас нет открытых игр. Создайте свою и поделитесь ссылкой!",
    "loadFailed": "Не удалось загрузить игры. Проверьте соединение и попробуйте ещё раз.",
    "hideRejoin": "Скрыть",
    "notice": {
      "kicked": "Вас удалили из игры.",
      "deleted": "Ведущий удалил игру.",
      "closed": "Модератор закрыл игру."
    }
  },
  "packages": {
    "title": "Паки",
    "search": "Поиск по названию",
    "language": "Язык",
    "anyLanguage": "Любой",
    "sort": "Сортировка",
    "sortNewest": "Новые",
    "sortTitle": "Название А–Я",
    "by": "автор {{name}}",
    "counts": "Раундов: {{rounds}} · вопросов: {{questions}}",
    "empty": "Ничего не найдено. Попробуйте другой запрос.",
    "loadFailed": "Не удалось загрузить паки.",
    "details": "О паке",
    "pickOne": "Выберите пак, чтобы увидеть раунды и провести с ним игру.",
    "rounds": "Раунды",
    "roundCounts": "тем: {{themes}} · вопросов: {{questions}}",
    "finalThemes": "Финальных тем: {{count}}",
    "has": "Есть {{list}}",
    "special": "Вопросы: {{list}}",
    "media": {
      "images": "изображения",
      "audio": "аудио",
      "video": "видео"
    },
    "host": "Провести игру с этим паком",
    "signInToHost": "Войдите, чтобы провести игру",
    "prev": "Назад",
    "next": "Дальше",
    "page": "Страница {{page}} из {{pages}}",
    "upload": "Загрузить пакет",
    "create": "Создать пакет",
    "sortOldest": "Старые",
    "sortTitleDesc": "Название Я–А",
    "sortAuthor": "Автор",
    "moreFilters": "Больше фильтров",
    "hideFilters": "Меньше фильтров",
    "age": "Возрастное ограничение",
    "anyAge": "Любое",
    "ageNone": "Для всех",
    "roundsRange": "Раунды",
    "questionsRange": "Вопросы",
    "min": "От",
    "max": "До",
    "onlyMine": "Только мои пакеты",
    "clearFilters": "Сбросить фильтры",
    "preview": "Посмотреть вопросы",
    "uploadUnfinished": "Загрузка не завершена",
    "uploadUnfinishedHelp": "Автор ещё загружает часть медиа этого пакета, поэтому начать с ним игру пока нельзя.",
    "uploadUnfinishedAuthor": "Часть медиафайлов не загружена, поэтому никто пока не может начать игру с этим пакетом. Завершите загрузку, чтобы в него можно было играть.",
    "resumeUpload": "Завершить загрузку"
  },
  "questionTypes": {
    "simple": "Обычный",
    "stake": "Ставка",
    "secret": "Кот в мешке",
    "noRisk": "Без риска",
    "hidden": "Скрытый",
    "choice": "С вариантами"
  },
  "create": {
    "back": "К пакам",
    "title": "Создание игры",
    "name": "Название игры",
    "defaultTitle": "Игра {{name}}",
    "players": "Игроки",
    "upTo": "До {{count}}",
    "age": "Возрастное ограничение",
    "ageNone": "Для всех",
    "whoCanJoin": "Кто может присоединиться",
    "public": "Все, у кого есть ссылка",
    "private": "По паролю",
    "password": "Пароль",
    "passwordPlaceholder": "Оставьте пустым — сгенерируем",
    "passwordHelp": "Буквы, цифры, - и _. Игроки вводят его один раз при входе.",
    "passwordInvalid": "До 16 букв, цифр, - или _.",
    "titleTooShort": "Название игры должно содержать не меньше 3 символов.",
    "submit": "Создать и открыть лобби",
    "creating": "Создаём…",
    "youAreShowman": "Вы будете ведущим. Игроки присоединятся по ссылке или коду комнаты.",
    "package": "Пак",
    "changePackage": "Сменить пак",
    "noPackage": "Сначала выберите пак.",
    "pickPackage": "К каталогу паков",
    "rules": {
      "title": "Правила",
      "falseStart": "Фальстарты",
      "falseStartHelp": "Кнопка открывается после того, как вопрос показан. Кто нажмёт раньше, блокируется на 3 секунды. Выключите, чтобы нажимать можно было в любой момент.",
      "pressMode": "Кто отвечает, если нажали несколько игроков",
      "modes": {
        "random_within_window": "Честный жребий",
        "first_wins": "Самый быстрый"
      },
      "modeHelp": {
        "random_within_window": "У всех, кто нажал в течение 0,3 с после первого, равные шансы, поэтому быстрый интернет не решает.",
        "first_wins": "Отвечает тот, чьё нажатие первым дошло до сервера."
      },
      "penalty": "За неверный ответ снимаются очки",
      "penaltyHelp": "Неверный ответ после нажатия кнопки отнимает стоимость вопроса. Выключите для более мягкой игры. Ставки при неверном ответе теряются всегда.",
      "roundLimit": "Время на раунд",
      "roundLimitHelp": "Когда время выйдет, раунд закончится после текущего вопроса, даже если вопросы остались.",
      "noLimit": "Без ограничения",
      "minutes": "{{count}} мин",
      "seconds": "{{count}} сек.",
      "timers": "Таймеры",
      "timer": {
        "answerMs": "Время, чтобы нажать кнопку",
        "answerSubmitMs": "Время на ответ после нажатия",
        "stakeMs": "Время на каждую ставку",
        "secretTransferMs": "Время, чтобы передать секретный вопрос",
        "allPlayAnswerMs": "Время на ответ, когда отвечают все",
        "finalAnswerMs": "Время на ответ в финале"
      },
      "startMode": "Начало игры",
      "startAutomatic": "Когда все готовы",
      "startManual": "Когда решит ведущий"
    }
  },
  "settings": {
    "title": "Настройки",
    "guestAccount": "Гостевой аккаунт",
    "displayName": "Отображаемое имя",
    "nameRequired": "Имя не может быть пустым.",
    "save": "Сохранить",
    "saved": "Сохранено ✓",
    "look": "Внешний вид",
    "theme": "Тема",
    "themes": {
      "midnight": "Midnight",
      "daylight": "Дневной свет",
      "broadcast": "Broadcast",
      "boldPop": "Bold Pop",
      "softParty": "Soft Party"
    },
    "comingLater": "Позже",
    "language": "Язык",
    "feel": "Звук и анимация",
    "sound": "Звуковые эффекты",
    "reduceMotion": "Меньше анимации",
    "volume": "Громкость медиа",
    "signOut": "Выйти",
    "guestSignOutHelp": "В гостевой аккаунт нельзя вернуться: в следующий раз будет новый гость.",
    "changeAvatar": "Сменить фото",
    "avatarSaving": "Сохраняем фото…",
    "avatarSaved": "Фото обновлено",
    "avatarErrors": {
      "notImage": "Этот файл не похож на изображение, которое мы можем прочитать.",
      "tooBig": "Изображение больше 20 МБ. Выберите поменьше.",
      "generic": "Не удалось сохранить фото. Попробуйте ещё раз."
    },
    "signOutFailed": "Не удалось выйти. Проверьте соединение и попробуйте ещё раз."
  },
  "join": {
    "notFound": "Игра не найдена",
    "notFoundHelp": "Нет открытой игры с кодом {{code}}. Возможно, она закончилась или в коде опечатка.",
    "finished": "Завершена",
    "finishedHelp": "Эта игра уже закончилась.",
    "signedInAs": "Вы присоединитесь как {{name}}.",
    "yourName": "Ваше имя",
    "guestHelp": "Мы создадим гостевой аккаунт с этим именем.",
    "otherSignIn": "Другие способы входа",
    "password": "Пароль игры",
    "passwordRequired": "Для этой игры нужен пароль.",
    "asPlayer": "Играть",
    "watch": "Смотреть",
    "lobbyHelp": "Игроки жмут кнопку и зарабатывают очки. Зрители видят всё, но не отвечают.",
    "playingHelp": "Игра уже идёт. Займите свободное место и играйте со следующего вопроса или смотрите.",
    "fullHelp": "Все места заняты. Можно смотреть и сесть, когда место освободится.",
    "passwordInvalid": "Используйте 1–16 латинских букв, цифры, - или _."
  },
  "game": {
    "joining": "Подключаемся к игре…",
    "joinFailed": "Не удалось подключиться к игре",
    "authFailed": "Сессия истекла. Войдите снова.",
    "tryAgain": "Попробовать ещё раз",
    "backHome": "К играм",
    "over": "Игра окончена",
    "finalRound": "Финал",
    "watching_one": "{{count}} смотрит",
    "watching_few": "{{count}} смотрят",
    "watching_many": "{{count}} смотрят",
    "watching_other": "{{count}} смотрят",
    "pause": "Пауза",
    "resume": "Продолжить",
    "scores": "Счёт",
    "noPlayers": "Игроков нет. Вы можете выбирать вопросы сами.",
    "roundLabel": "Раунд {{n}} · {{name}}",
    "rounds": {
      "title": "Раунды пакета",
      "position": "{{current}} из {{total}}",
      "open": "Раунды. {{position}}. Сейчас: {{name}}",
      "done": "Пройдено",
      "current": "Сейчас",
      "next": "Далее"
    },
    "you": "Вы:",
    "youAre": "Ваша роль: {{role}}",
    "delete": "Удалить игру",
    "deleteConfirm": "Удалить эту игру для всех?",
    "deleteYes": "Да, удалить",
    "deleteNo": "Отмена",
    "roundEndsIn": "Раунд закончится через {{time}}",
    "roundTimeUp": "Последний вопрос раунда",
    "takenOver": "Открыто в другом месте",
    "takenOverHelp": "Ваш аккаунт присоединился к этой игре в другой вкладке или на другом устройстве, поэтому здесь игра остановлена. Ваше место и очки сохранены.",
    "takeOver": "Играть здесь",
    "leaving": "Выходим…",
    "leaveFailed": "Не удалось выйти из игры. Попробуйте ещё раз."
  },
  "lobby": {
    "leave": "Выйти из лобби",
    "youAre": "Вы —",
    "kicker": "Лобби · ждём игроков",
    "players": "Игроки",
    "readyCount": "Готовы {{count}} из {{total}}",
    "openSlot": "Свободное место",
    "waitingForPlayer": "Ждём игрока",
    "clickToSit": "Нажмите, чтобы сесть",
    "takeSlot": "Занять место {{n}}",
    "ready": "Готов",
    "notReady": "Ещё не готов",
    "offline": "Офлайн — место сохранено",
    "spectators": "Зрители",
    "watching_one": "{{count}} смотрит",
    "watching_few": "{{count}} смотрят",
    "watching_many": "{{count}} смотрят",
    "watching_other": "{{count}} смотрят",
    "spectatorsHelp": "Зрители видят всё, но не могут жать кнопку или делать ставки.",
    "youreSeated": "Вы на месте {{n}} как игрок",
    "imReady": "Я готов",
    "readyUndo": "✓ Готов — нажмите, чтобы отменить",
    "readyHelp": "Игра начнётся, когда все подключённые игроки будут готовы. Ведущий также может начать раньше.",
    "waitingForHost": "Ждём, пока {{name}} начнёт · готовы {{ready}} из {{total}}.",
    "watchInstead": "Лучше смотреть",
    "youreWatching": "Вы смотрите",
    "spectatorHelp": "Займите свободное место, чтобы играть. Вернуться можно в любой момент до начала игры.",
    "noSeats": "Все места заняты. До старта место может освободиться.",
    "takeSeat": "Занять место",
    "startTitle": "Начать игру",
    "checkPackage": "Пак загружен",
    "checkPlayers_one": "В комнате {{count}} игрок",
    "checkPlayers_few": "В комнате {{count}} игрока",
    "checkPlayers_many": "В комнате {{count}} игроков",
    "checkPlayers_other": "В комнате {{count}} игрока",
    "checkNoPlayers": "Игроков пока нет — поделитесь приглашением",
    "checkAllReady": "Все готовы",
    "checkNotReady_one": "Ещё не готов {{count}} игрок",
    "checkNotReady_few": "Ещё не готовы {{count}} игрока",
    "checkNotReady_many": "Ещё не готовы {{count}} игроков",
    "checkNotReady_other": "Ещё не готовы {{count}} игрока",
    "start": "Начать игру",
    "startHelp": "Начать можно в любой момент. Когда все готовы, игра стартует сама.",
    "startAloneHelp": "Можно начать одному, чтобы проверить пак, но жать кнопку будет некому.",
    "invite": "Приглашение",
    "inviteLink": "Ссылка-приглашение",
    "copy": "Копировать",
    "copied": "Скопировано",
    "roomCode": "Код комнаты",
    "password": "Пароль",
    "kick": "Удалить {{name}} из игры",
    "moveToSpectators": "Перевести {{name}} в зрители",
    "moreSeats_one": "Ещё {{count}} свободное место",
    "moreSeats_few": "Ещё {{count}} свободных места",
    "moreSeats_many": "Ещё {{count}} свободных мест",
    "moreSeats_other": "Ещё {{count}} свободного места",
    "readyManualHelp": "Отметьте готовность. Ведущий решает, когда начать игру.",
    "waitingForReady": "{{ready}} / {{total}} игроков готовы. Ждём готовности всех.",
    "startManualHelp": "Готовность — это сигнал для вас. Игра начнётся только после нажатия «Начать».",
    "automaticMode": "Автоматический старт · когда все подключённые игроки готовы.",
    "manualMode": "Старт по решению ведущего · готовые игроки ждут ведущего.",
    "showmanOpen": "Место ведущего свободно",
    "showmanHelp": "Ведёт игру и оценивает ответы",
    "becomeShowman": "Стать ведущим",
    "packageOverview": "Раунды и темы",
    "packageUnavailable": "Не удалось загрузить обзор пакета.",
    "finalRound": "Финальный раунд"
  },
  "banner": {
    "reconnecting": "Соединение потеряно — переподключаемся…",
    "reconnectingHelp": "Ваше место и счёт сохранены. Как только вы вернётесь, экран догонит игру."
  },
  "pause": {
    "title": "Игра на паузе",
    "waiting": "Ждём, пока ведущий продолжит игру."
  },
  "chat": {
    "title": "Чат",
    "empty": "Сообщений пока нет. Поздоровайтесь!",
    "message": "Сообщение",
    "placeholder": "Сообщение — пробел не жмёт кнопку, пока вы пишете",
    "muted": "Ведущий запретил вам писать",
    "send": "Отправить",
    "someone": "Кто-то",
    "unread_one": "{{count}} непрочитанное сообщение",
    "unread_few": "{{count}} непрочитанных сообщения",
    "unread_many": "{{count}} непрочитанных сообщений",
    "unread_other": "{{count}} непрочитанного сообщения",
    "log": {
      "start": "начал игру",
      "pause": "поставил игру на паузу",
      "unpause": "продолжил игру",
      "reveal": "показал ответ",
      "buzzerOpen": "открыл кнопку раньше",
      "nextRound": "перешёл к следующему раунду",
      "nextRoundNamed": "перешёл к следующему раунду: {{round}}",
      "pick": "выбрал {{theme}} за {{price}}",
      "toggleRemoved": "убрал с поля {{theme}} за {{price}}",
      "toggleRestored": "вернул на поле {{theme}} за {{price}}",
      "answerRight": "засчитал ответ {{player}} ({{points}})",
      "answerWrong": "не засчитал ответ {{player}} ({{points}})",
      "answerSkipped": "пропустил ответ {{player}} ({{points}})",
      "undo": "отменил решение по {{player}} ({{points}})",
      "joinMode": "изменил, кто может присоединиться: {{mode}}",
      "kick": "убрал {{player}} из игры",
      "restrictBanned": "заблокировал {{player}}",
      "restrictRestricted": "разрешил {{player}} только смотреть",
      "restrictMuted": "отключил чат для {{player}}",
      "restrictCleared": "снял ограничения с {{player}}",
      "role": "сделал {{player}}: {{role}}",
      "score": "изменил счёт {{player}} на {{score}}",
      "slot": "пересадил {{player}} на место {{slot}}",
      "turn": "передал выбор {{player}}",
      "turnNone": "забрал выбор себе",
      "secret": "отдал вопрос {{player}}",
      "reviewRight": "засчитал ответ {{player}}",
      "reviewWrong": "не засчитал ответ {{player}}",
      "theme": "убрал тему {{theme}}",
      "rules": "изменил правила: {{changes}}",
      "ruleOn": "включено",
      "ruleOff": "выключено"
    },
    "system": "Система"
  },
  "menu": {
    "title": "Меню игры",
    "shortcuts": "Горячие клавиши",
    "keys": {
      "buzz": "Нажать кнопку",
      "option": "Выбрать вариант ответа",
      "judge": "Верно / неверно (ведущий)",
      "chat": "Открыть чат",
      "menu": "Это меню"
    },
    "feel": "Звук и анимация",
    "host": "Инструменты ведущего",
    "hostHelp": "В «Управлять игроками» можно исправить счёт, передать ход или удалить игрока. Удаление игры вернёт всех на главную.",
    "skipQuestion": "Пропустить вопрос",
    "nextRound": "К следующему раунду",
    "spectate": "Стать зрителем",
    "leave": "Выйти из игры",
    "skipReveal": "Пропустить показ ответа",
    "managePlayers": "Управлять игроками",
    "hostShort": "Ведущий",
    "undoRuling": "Отменить последнюю оценку",
    "boardEdit": "Убрать вопросы",
    "boardEditDone": "Готово",
    "joinMode": "Кто может войти",
    "joinModes": {
      "open": "Все",
      "spectators_only": "Только зрители",
      "closed": "Никто новый"
    },
    "rules": {
      "title": "Правила игры",
      "help": "Изменения действуют со следующего таймера или вопроса; уже идущий таймер не изменится. Все увидят изменение в чате.",
      "save": "Сохранить",
      "saving": "Сохраняем…",
      "reset": "Отменить изменения"
    },
    "info": {
      "title": "Об игре",
      "playersHelp": "Сейчас в игре игроков: {{count}}; мест не может быть меньше.",
      "newPassword": "Новый пароль",
      "passwordPlaceholder": "Оставьте пустым, чтобы не менять",
      "passwordHelp": "Буквы, цифры, _ и -, до 16 символов. Игроки, которые уже в игре, остаются.",
      "saved": "Сохранено ✓"
    }
  },
  "keys": {
    "space": "Пробел"
  },
  "phases": {
    "lobby": "Лобби",
    "choosing": "Выбор вопроса",
    "media": "Загрузка вопроса",
    "showing": "Можно жать",
    "answering": "Ответ",
    "reveal": "Ответ",
    "secret_transfer": "Кот в мешке",
    "stake_bidding": "Ставка · аукцион",
    "final_elimination": "Выбор темы",
    "final_bidding": "Финал · ставки",
    "final_answering": "Финал · ответы",
    "final_reviewing": "Финал · проверка",
    "finished": "Игра окончена",
    "all_play_bidding": "Все · ставки",
    "all_play_answering": "Отвечают все",
    "all_play_reviewing": "Все · проверка"
  },
  "questionOpening": {
    "opening": "Открываем вопрос",
    "waiting": "Ожидание загрузки медиа всеми игроками..."
  },
  "reasons": {
    "question_opening": "Открываем вопрос — дождитесь завершения перехода",
    "wrong_role": "Это могут только игроки",
    "wrong_role_watch": "Вы зритель — зрители не жмут кнопку",
    "wrong_phase": "Сейчас недоступно",
    "not_your_turn": "Не ваш ход",
    "already_done": "Вы уже отвечали на этот вопрос",
    "not_eligible": "Вы присоединились после начала этого вопроса",
    "waiting_for_media": "Кнопка откроется, когда вопрос загрузится у всех",
    "waiting_for_server": "Отправляем…",
    "connection_lost": "Переподключение — действия приостановлены",
    "paused": "Игра на паузе",
    "skipped": "Вы пропустили этот вопрос",
    "false_start": "Вы нажали слишком рано — подождите немного"
  },
  "chips": {
    "offline": "офлайн",
    "picks": "выбирает",
    "loading": "загружает…",
    "answering": "отвечает",
    "passed": "пас",
    "givingAway": "отдаёт",
    "choosingPrice": "выбирает цену",
    "bidding": "ставит",
    "removing": "убирает",
    "bidPlaced": "ставка сделана",
    "answered": "ответил",
    "typing": "пишет",
    "someone": "кто-то"
  },
  "board": {
    "caption": "Табло раунда: {{round}}",
    "picker": "Выбирает {{name}}",
    "cell": "{{theme}}, {{price}}",
    "played": "{{theme}}, {{price}}, уже сыгран",
    "editHint": "Нажмите на вопрос, чтобы убрать его с табло, или на зачёркнутый, чтобы вернуть."
  },
  "question": {
    "region": "Вопрос",
    "image": "Изображение к вопросу",
    "audio": "Аудио к вопросу",
    "getReady": "Приготовьтесь…",
    "mediaReady": "Вопрос загрузился у {{ready}} из {{total}} игроков",
    "noContent": "Ведущий зачитает этот вопрос вслух.",
    "noRiskHelp": "Без риска: за неверный ответ очки не снимаются",
    "options": "Варианты ответа",
    "optionsSoon": "Варианты появятся через мгновение…",
    "showmanPreview": "Пока вопрос не загрузится у всех игроков, его видите только вы.",
    "mediaFailed": {
      "image": "Не удалось загрузить изображение",
      "video": "Не удалось загрузить видео",
      "audio": "Не удалось загрузить аудио"
    },
    "mediaFailedHelp": "Сервер файлов не отвечает. Ведущий может прочитать вопрос вслух или пропустить его.",
    "openFile": "Открыть файл",
    "mediaLoading": "Загрузка…",
    "audioPlaying": "Слушайте",
    "audioWaiting": "Аудио заиграет, когда откроется вопрос",
    "enableSound": "Нажмите, чтобы включить звук",
    "step": "Часть {{current}} из {{total}}",
    "stepsLabel": "Части вопроса",
    "recap": "Вопрос: {{text}}",
    "audioEnded": "Закончилось",
    "replay": "Повторить показ",
    "optionNumber": "Вариант {{n}}",
    "mediaTab": "Медиа",
    "textTab": "Текст",
    "scrollHint": "Прокрутите, чтобы прочитать дальше",
    "expandOption": "Открыть вариант {{n}}"
  },
  "showman": {
    "panel": "Видите только вы",
    "onlyYou": "Ответ · видите только вы",
    "answer": "Правильный ответ",
    "noAnswerText": "В паке нет текста ответа",
    "hint": "Подсказка: {{hint}}",
    "answering": "Отвечает <player>{{name}}</player>:",
    "sayingOutLoud": "Отвечает вслух",
    "emptySubmission": "Текст ответа не получен.",
    "alreadyAnswered": "Уже отвечали",
    "comment": "Инструкция ведущему",
    "alsoRight": "Тоже верно: {{answers}}",
    "notRight": "Неверно: {{answers}}",
    "number": "Верное число: {{number}}{{deviation}}",
    "autoChecked": "Игра автоматически проверяет распознанные ответы."
  },
  "reveal": {
    "answer": "Ответ",
    "gotIt": "<player>{{name}}</player> отвечает правильно · <points>{{points}}</points>",
    "nobody": "Никто не ответил правильно.",
    "correctPlayers": "Правильно ответили: {{players}}",
    "correctCount": "Правильно: {{correct}}/{{total}}",
    "noSubmissions": "Никто не отправил ответ.",
    "unresolved": "Некоторые ответы ещё не оценены.",
    "playerFallback": "Игрок {{id}}",
    "submitted": "<player>{{name}}</player> ответил(а): «{{answer}}»",
    "alsoRight": "Также принимается: <answers>{{answers}}</answers>",
    "authors": "Автор: {{names}}",
    "sources": "Источник: {{list}}"
  },
  "secret": {
    "youPicked": "Вам выпал кот в мешке. Кому отдать вопрос?",
    "picked": "<player>{{name}}</player> получает кота в мешке и выбирает, кто будет отвечать.",
    "ruleAny": "Вопрос можно отдать любому игроку, в том числе себе. Отвечает только он — без кнопки.",
    "ruleExcept": "Вопрос нужно отдать другому игроку. Отвечает только он — без кнопки.",
    "giveTo": "Отдать вопрос",
    "prices": "Варианты стоимости",
    "pickPriceYou": "Вопрос ваш — выберите его стоимость",
    "pickPrice": "<player>{{name}}</player> получает вопрос и выбирает стоимость"
  },
  "stake": {
    "kicker": "Ставка · аукцион",
    "rules": "Вопрос получает тот, кто поставит больше всех, и отвечает сам. Стартовая цена {{start}}, максимум {{max}}.",
    "noLimit": "ваш счёт",
    "bids": "Ставки по очереди",
    "passed": "пас",
    "theirTurn": "его ход",
    "bid": "ставка",
    "waiting": "ждёт"
  },
  "final": {
    "mediaTimedOut": "Не все игроки успели загрузить медиа. Вопрос уже начался, поэтому часть содержимого может быть недоступна.",
    "themesTitle": "Темы финала",
    "themesHelp": "Игроки по очереди убирают темы. Последняя тема станет финальным вопросом.",
    "removed": "Убрана",
    "remove": "Убрать",
    "finalTheme": "Финальная тема",
    "removeTheme": "Убрать тему {{name}}",
    "themeRemoved": "{{name}}, убрана",
    "theme": "Финал · {{name}}",
    "bidPrompt": "Сделайте ставку, прежде чем увидите вопрос.",
    "bidPlaced": "ставка сделана",
    "bidding": "ставит",
    "answered": "ответил",
    "typing": "пишет",
    "answers": "Ответы финала",
    "bid": "ставка",
    "noAnswer": "Нет ответа",
    "judging": "Проверяется",
    "autoLoss": "Нет ответа · {{points}}"
  },
  "finished": {
    "wins": "Побеждает {{name}}!",
    "tie": "Ничья!",
    "noPlayers": "Игра окончена",
    "podium": "Пьедестал",
    "place": "{{n}} место"
  },
  "judge": {
    "correct": "Верно",
    "wrong": "Неверно",
    "more": "Другие решения",
    "double": "×2 {{points}}",
    "correctDoubleLabel": "Верно, двойные очки: +{{points}}",
    "wrongDoubleLabel": "Неверно, двойной штраф: −{{points}}",
    "skipZero": "Пропустить, 0"
  },
  "bid": {
    "quick": "Быстрые ставки",
    "slider": "Ползунок ставки",
    "detailsUnavailable": "Данные для ставки недоступны. Дождитесь обновления игры.",
    "afterAllIn": "После ва-банка можно только пойти ва-банк или пасовать.",
    "noRegularBid": "Обычная ставка недоступна.",
    "waitTimer": "Доступных ставок нет. Дождитесь таймера.",
    "amount": "Ваша ставка",
    "bid": "Поставить {{amount}}",
    "range": "Ставка {{min}} – {{max}}",
    "allIn": "Ва-банк {{amount}}",
    "pass": "Пас"
  },
  "admin": {
    "manage": "Управление: {{name}}",
    "score": "Счёт",
    "setScore": "Изменить счёт",
    "scoreHelp": "Все увидят изменение на табло.",
    "giveTurn": "Передать ход",
    "isTurn": "Сейчас его ход",
    "toSpectators": "Перевести в зрители",
    "kick": "Удалить из игры",
    "mute": "Отключить чат",
    "unmute": "Включить чат",
    "muteHelp": "Игрок остаётся в игре, но не может писать в чат.",
    "restrict": "Оставить зрителем",
    "unrestrict": "Разрешить играть снова",
    "restrictHelp": "Переводит в зрители и не даёт занять место игрока.",
    "ban": "Заблокировать в этой игре",
    "banConfirm": "Да, заблокировать {{name}}",
    "banHelp": "Удаляет из игры без возможности вернуться."
  },
  "announce": {
    "correct": "{{name}} отвечает верно, {{points}}",
    "wrong": "{{name}} ошибается, {{points}}",
    "skipped": "ответ {{name}} пропущен, {{points}}",
    "yourTurn": "Ваш ход"
  },
  "dock": {
    "region": "Ваше действие",
    "next": "Что дальше",
    "sending": "Отправляем…",
    "reconnecting": "Переподключение",
    "offlineInfo": "Действия приостановлены, пока вы не вернётесь",
    "paused": "Пауза",
    "choosing": {
      "yourTurn": "Ваш ход — выбирайте",
      "pickInfo": "Выберите любую жёлтую клетку на табло",
      "isPicking": "Выбирает <player>{{name}}</player>",
      "showmanPicks": "Следующий вопрос выбирает ведущий",
      "showmanStatus": "Следующим выбирает <player>{{name}}</player>",
      "youPick": "Выберите следующий вопрос",
      "showmanInfo": "Дождитесь выбора игрока или выберите за него",
      "pickAny": "Выберите любую клетку на табло",
      "randomQuestion": "Случайный вопрос",
      "noQuestions": "Вопросов не осталось",
      "next": "Как только вопрос выберут, он откроется для всех.",
      "nextYou": "Вопрос откроется для всех сразу после вашего выбора.",
      "unknownShowman": "Выбирает игрок — или выберите за него",
      "unknown": "Первый выбор",
      "unknownInfo": "Если сейчас ваш ход, выберите любую клетку на табло",
      "watching": "Вы смотрите, как выбирают вопрос"
    },
    "media": {
      "status": "Готовы {{ready}} из {{total}} игроков",
      "finalWait": "Ожидаем, пока игроки загрузят финальный вопрос.",
      "finalNext": "Финальный вопрос начнётся, когда медиа будет готово.",
      "next": "Кнопка откроется, как только вопрос загрузится у всех игроков."
    },
    "showing": {
      "status": "Игроки могут жать",
      "open": "Кнопка открыта",
      "buzz": "Жми!",
      "pass": "Пас",
      "unpass": "Отменить пропуск",
      "wrongCost": "Неверно: −{{points}}, и кнопка откроется для остальных",
      "wrongFree": "Неверно: без штрафа",
      "next": "Отвечает тот, кто нажмёт первым. Верно: +{{points}}. {{wrong}}.",
      "showmanStatus": "Ждём, кто нажмёт",
      "revealAnswer": "Никто не знает — показать ответ",
      "showmanNext": "Если время выйдет и никто не нажмёт, ответ покажется автоматически.",
      "wait": "Кнопка откроется после вопроса",
      "waitButton": "Подождите…",
      "earlyHint": "Если нажать до открытия кнопки, она заблокируется на 3 секунды.",
      "locked": "Фальстарт! Нажать снова можно через {{seconds}} сек.",
      "nextWindow": "У всех, кто нажал в первые доли секунды, равные шансы. Верно: +{{points}}. {{wrong}}.",
      "showmanWait": "Вопрос ещё звучит — кнопка откроется после него",
      "openBuzzer": "Открыть кнопку сейчас",
      "showmanNextEarly": "Кнопка откроется, когда вопрос закончится. Откройте её сейчас, чтобы игроки могли жать раньше.",
      "inDraw": "Вы в жеребьёвке…"
    },
    "answering": {
      "autoSubmitted": "<player>{{name}}</player> отправил ответ — ожидаем результат",
      "autoSubmittedHelp": "Ответ отправлен. Дождитесь результата или пропустите без очков.",
      "questionLoading": "Ожидаем данные вопроса.",
      "autoWait": "Отвечает <player>{{name}}</player> — дождитесь действия игрока",
      "autoWaitHelp": "Игрок должен самостоятельно выбрать, ввести или отметить ответ.",
      "autoWaitNext": "Если возможно, ответ проверят автоматически.",
      "judge": "Отвечает <player>{{name}}</player> — оцените",
      "showmanNext": "Верно: {{name}} получает очки и выбирает следующий. Неверно: −{{points}}, и кнопка откроется снова.",
      "showmanNextSingle": "На этот вопрос отвечает только {{name}}. В любом случае дальше будет ответ.",
      "you": "Вы отвечаете!",
      "pickOption": "Выберите вариант или нажмите его номер",
      "typeLabel": "Ваш ответ",
      "typePlaceholder": "Скажите вслух или напишите здесь",
      "send": "Отправить",
      "sent": "Отправлено ✓",
      "giveUp": "Сдаться",
      "autoNext": "Распознанные ответы проверяются автоматически. Если результат не придёт, ведущий может пропустить ответ без очков.",
      "youNext": "Ведущий оценит ответ. За ошибку снимут очки, и кнопка откроется для остальных.",
      "choiceNext": "Распознанные ответы проверяются автоматически. Если результат не придёт, ведущий может пропустить ответ без очков.",
      "youNextSingle": "Ведущий оценит ответ. В любом случае дальше покажут правильный ответ.",
      "other": "Отвечает <player>{{name}}</player>",
      "wait": "Ждите решения ведущего",
      "otherNext": "Если {{name}} ошибётся, кнопка откроется для всех остальных.",
      "otherNextSingle": "На этот вопрос отвечает только {{name}}.",
      "showmanChoice": "Игра проверит ответ {{name}}, если это возможно. Оцените его, если нужна проверка.",
      "numberPlaceholder": "Введите число"
    },
    "reveal": {
      "correct": "<player>{{name}}</player> отвечает правильно · <points>{{points}}</points>",
      "nobody": "Вот ответ",
      "continue": "Дальше",
      "info": "Сейчас вернёмся к табло",
      "next": "Следующий вопрос выбирает {{name}}.",
      "nextBoard": "Дальше — табло."
    },
    "secret": {
      "choose": "Выберите, кто будет отвечать",
      "giveQ": "Отдать <player>{{name}}</player>?",
      "otherChoosing": "<player>{{name}}</player> выбирает, кто будет отвечать",
      "give": "Отдать: {{name}}",
      "pickFirst": "Сначала выберите игрока",
      "wait": "Подождите — вопрос может достаться вам",
      "next": "Ответить обязательно: +{{points}}, если верно, −{{points}}, если нет.",
      "nextNoPrice": "Отвечает только выбранный игрок.",
      "priceYou": "Выберите стоимость вопроса",
      "priceOther": "<player>{{name}}</player> выбирает стоимость",
      "priceWait": "Ждём, пока {{name}} выберет стоимость",
      "priceNext": "За верный ответ — выбранная стоимость, за неверный — минус столько же. Если время выйдет, возьмётся минимальная.",
      "priceAbove": "Выберите стоимость вопроса сверху"
    },
    "stake": {
      "waitFor": "Ждём ставку от <player>{{name}}</player>",
      "watching": "Игроки делают ставки — пока ничего делать не нужно",
      "beat": "Ваша ставка — больше {{amount}}",
      "open": "Ваша ставка",
      "next": "Наибольшая ставка получает вопрос и отвечает сама: + ставка, если верно, − ставка, если нет. Пас окончательный."
    },
    "final": {
      "elimYou": "Ваш ход — уберите одну тему",
      "elimOther": "<player>{{name}}</player> убирает тему",
      "elimShowman": "<player>{{name}}</player> убирает тему",
      "elimInfo": "Нажмите на тему, которая вам не нужна",
      "elimNext_one": "Осталась {{count}} тема — она станет финальным вопросом.",
      "elimNext_few": "Осталось {{count}} темы. Игроки убирают по очереди, пока не останется одна.",
      "elimNext_many": "Осталось {{count}} тем. Игроки убирают по очереди, пока не останется одна.",
      "elimNext_other": "Осталось {{count}} темы. Игроки убирают по очереди, пока не останется одна.",
      "bidRange": "Ставка 1 – {{max}}",
      "placeBid": "Сделать ставку",
      "bidSubmitted": "Ставка принята",
      "bidLocked": "Ваша ставка: {{amount}}",
      "waitOthers": "Готовы {{done}} из {{total}} — ждём остальных",
      "bidsIn": "Ставок: {{done}} из {{total}}",
      "bidShowman": "Игроки делают скрытые ставки",
      "bidNext": "Ставки скрыты до проверки. Игроки с 0 и меньше пропускают финал.",
      "sitOut": "Вы пропускаете финал",
      "typeAnswer": "Напишите ответ · ставка {{amount}}",
      "pointAnswer": "Выберите точку · ставка {{amount}}",
      "pointNext": "Выберите точку на изображении, чтобы ответить. Если время истечёт без ответа, ставка проиграет.",
      "answerLabel": "Ваш ответ в финале",
      "answerPlaceholder": "Напишите ответ",
      "submit": "Отправить",
      "answerLocked": "Ответ принят",
      "answersIn": "Ответов: {{done}} из {{total}}",
      "answerShowman": "Игроки отвечают",
      "contentPlaying": "Показ вопроса",
      "contentWait": "Сначала посмотрите вопрос.",
      "contentNext": "Ответить можно будет после показа вопроса.",
      "answerNext": "Ответы покажут при проверке. Когда время выйдет, отправится то, что вы успели написать.",
      "reviewStatus": "Проверено {{done}} из {{total}}",
      "reviewShowman": "Оцените каждый ответ на сцене",
      "reviewWait": "Ведущий проверяет ответы",
      "reviewNext": "Счёт обновляется после каждой оценки. Победителя покажут после последней."
    },
    "finished": {
      "place": "Ваше место: {{n}}",
      "status": "Спасибо за игру",
      "back": "К играм",
      "next": "Проведите новую игру с любым паком или присоединитесь к открытой."
    },
    "allPlay": {
      "stakeWatch": "Игроки делают ставки",
      "stakeLocked": "Ставка сделана",
      "stakeNext": "Когда все поставят, вопрос покажется всем.",
      "typeAnswer": "Напишите ответ — на этот вопрос отвечают все",
      "answerWatch": "Игроки пишут ответы",
      "answerNextStakeAuto": "Распознанные ответы проверяются автоматически, нераспознанные оценивает ведущий. За верный ответ вы выигрываете ставку, за ошибку — теряете.",
      "answerNextNoRiskAuto": "Распознанные ответы проверяются автоматически, нераспознанные оценивает ведущий. За верный ответ — {{points}}, за ошибку — без потерь.",
      "answerNextStake": "Когда время выйдет, ведущий проверит все ответы. Верно — выигрываете ставку, неверно — теряете.",
      "answerNextNoRisk": "Когда время выйдет, ведущий проверит все ответы. Верно — {{points}}, неверно — без потерь.",
      "reviewShowman": "Оцените каждый ответ на сцене",
      "reviewNext": "Когда все ответы оценены, покажется правильный."
    }
  },
  "errors": {
    "connection_lost": "Вы офлайн. Переподключаемся…"
  },
  "notices": {
    "joined": "{{name}} присоединяется",
    "back": "{{name}} возвращается",
    "left": "{{name}} выходит — место и счёт сохранены",
    "kicked": "{{name}} удалён из игры",
    "stakeWinner": "{{name}} выигрывает аукцион со ставкой {{amount}} и отвечает сам",
    "secretTransfer": "Кот в мешке достаётся {{name}}",
    "scoreChanged": "Ведущий меняет счёт {{name}} на {{score}}",
    "turnChanged": "Следующим выбирает {{name}}"
  },
  "players": {
    "title": "Игроки и счёт",
    "button": "Игроки",
    "scores": "Счёт",
    "none": "Игроков пока нет.",
    "picksNext": "выбирает следующим",
    "manage": "Управлять",
    "noShowman": "Сейчас нет ведущего",
    "noSpectators": "Никто не смотрит.",
    "seat": "Сделать игроком",
    "showmanHelp": "Нажмите «Управлять», чтобы исправить счёт, передать ход, перевести в зрители или удалить игрока.",
    "viewAvatar": "Открыть аватар {{name}}",
    "avatar": "Аватар {{name}}",
    "currentValue": "Стоимость текущего вопроса",
    "lastValue": "Стоимость последнего вопроса",
    "valueUnavailable": "Стоимость предыдущего вопроса неизвестна. Счёт можно изменить в управлении игроком.",
    "addScore": "Добавить {{amount}} игроку {{name}}",
    "subtractScore": "Вычесть {{amount}} у игрока {{name}}"
  },
  "upload": {
    "finalMedia": {
      "unavailable": "Не удалось определить длительность файла {{name}} для финального вопроса. Проверьте файл и повторите попытку.",
      "tooLong": "Длительность {{name}} превышает две минуты. Сократите файл или время его показа для финального вопроса."
    },
    "pointImageDimensions": "Не удалось определить размеры первого изображения для ответа точкой. Проверьте изображение и повторите попытку.",
    "back": "Пакеты",
    "title": "Загрузить пакет",
    "lead": "Добавьте пакет SIGame .siq или экспорт OpenQuester .oq. Вы увидите содержимое ещё до загрузки.",
    "signInFirst": "Войдите, чтобы загружать пакеты.",
    "guestTitle": "Гостевые аккаунты не могут загружать пакеты",
    "guestHelp": "У пакета должен быть владелец, который может к нему вернуться. Войдите через Discord, и ваши пакеты останутся в вашем аккаунте.",
    "discordUnavailable": "Вход через Discord на этом сайте ещё не включён, поэтому загрузка здесь недоступна.",
    "drop": "Перетащите файл пакета сюда",
    "formats": "SIGame .siq (форматы 4 и 5) или OpenQuester .oq.",
    "choose": "Выбрать файл",
    "reading": "Читаем {{name}}…",
    "readErrors": {
      "wrongType": "Это не файл .siq или .oq.",
      "notZip": "Файл повреждён или не является архивом пакета.",
      "noContentXml": "В этом .siq нет content.xml, читать нечего.",
      "badContentXml": "Описание пакета внутри этого .siq повреждено.",
      "noContentJson": "В этом .oq нет content.json, читать нечего.",
      "badContentJson": "Описание пакета внутри этого .oq повреждено.",
      "generic": "Не удалось прочитать файл.",
      "otherSource": "Это не тот файл, из которого загрузили пакет, поэтому им нельзя завершить эту загрузку. Загрузите его как новый пакет.",
      "allHtmlQuestions": "После импорта не осталось пригодных вопросов. В других вопросах могут отсутствовать медиафайлы.",
      "ambiguousManifest": "Архив содержит несколько противоречивых манифестов пакета."
    },
    "format": {
      "siq": "Пакет SIGame",
      "oq": "Пакет OpenQuester"
    },
    "questionCount_one": "{{count}} вопрос",
    "questionCount_few": "{{count}} вопроса",
    "questionCount_many": "{{count}} вопросов",
    "questionCount_other": "{{count}} вопроса",
    "mediaCount_one": "{{count}} медиафайл · {{size}}",
    "mediaCount_few": "{{count}} медиафайла · {{size}}",
    "mediaCount_many": "{{count}} медиафайлов · {{size}}",
    "mediaCount_other": "{{count}} медиафайла · {{size}}",
    "noQuestions": "В файле нет вопросов, которые можно сыграть, загружать нечего.",
    "warningsTitle_one": "При чтении изменена {{count}} вещь",
    "warningsTitle_few": "При чтении изменены {{count}} вещи",
    "warningsTitle_many": "При чтении изменено {{count}} вещей",
    "warningsTitle_other": "При чтении изменены {{count}} вещи",
    "warningsHelp": "Пакет всё равно загрузится. Эти вопросы могут отличаться от оригинала.",
    "warnings": {
      "missingFile": "Медиафайла {{detail}} нет в архиве, он пропущен.",
      "externalMedia": "Медиа по ссылке ({{detail}}) нельзя загрузить, оно пропущено.",
      "emptyQuestion": "Вопрос без текста и медиа, поэтому пропущен.",
      "noAnswer": "У вопроса нет ответа. Ведущий оценит без него.",
      "choiceAsSimple": "В вопросе с выбором меньше двух вариантов, поэтому он играется как обычный.",
      "choiceCorrectUnresolved": "Нужно исправить правильный вариант. Откройте вопрос в редакторе и выберите его снова.",
      "unknownType": "Тип вопроса «{{detail}}» пока не поддерживается и играется как обычный.",
      "finalAsSimple": "Финальный раунд не на последней позиции преобразован в обычный. Проверьте вопросы и их стоимость.",
      "extraFinalQuestions": "Импортирован только первый вопрос этой финальной темы; пропущено дополнительных вопросов: {{detail}}. Проверьте исходный архив.",
      "hashMismatch": "Медиафайл {{detail}} повреждён и пропущен.",
      "htmlQuestionRemoved": "Неподдерживаемый HTML-вопрос удалён."
    },
    "showAll": "Показать все {{count}}",
    "showFewer": "Показать меньше",
    "upload": "Загрузить пакет",
    "another": "Выбрать другой файл",
    "progressLabel": "Ход загрузки",
    "creating": "Создаём пакет…",
    "sending": "Загружаем медиа {{done}} из {{total}} · {{sent}} из {{size}}",
    "keepOpen": "Не закрывайте страницу, пока загрузка не закончится.",
    "done": "Пакет загружен",
    "doneHelp": "«{{title}}» готов. Создайте игру с ним сейчас или найдите его позже в Пакетах.",
    "viewPackage": "Открыть пакет",
    "partial_one": "{{count}} медиафайл не загрузился",
    "partial_few": "{{count}} медиафайла не загрузились",
    "partial_many": "{{count}} медиафайлов не загрузились",
    "partial_other": "{{count}} медиафайла не загрузились",
    "retryFiles": "Повторить эти файлы",
    "tryAgain": "Попробовать снова",
    "networkError": "Во время загрузки пропала связь. Проверьте сеть и попробуйте снова.",
    "serverRejected": "Сервер не принял пакет: {{message}}",
    "editFirst": "Редактировать перед загрузкой",
    "compress": {
      "label": "Медиа автоматически готовятся к загрузке",
      "help": "Файлы могут быть сжаты или преобразованы в другой формат. Медиа, уже подготовленные в редакторе, и файлы, которые браузер не может преобразовать, останутся без изменений.",
      "progress": "Сжимаем медиа: {{done}} из {{total}} · {{before}} → {{after}}",
      "saved": "Медиа сжато с {{before}} до {{after}}.",
      "before": "Текущий размер медиа",
      "estimate": "Примерно после сжатия",
      "estimating": "Оцениваем…",
      "estimateHelp": "Примерный размер медиа, а не архива. Результат может отличаться; для файлов, которые не удалось оценить, учтён текущий размер. Файлы, уже находящиеся в хранилище, могут не занимать дополнительное место."
    },
    "checking": "Проверяем, что все файлы дошли…",
    "fileType": {
      "image": "Картинка",
      "audio": "Звук",
      "video": "Видео"
    },
    "fileState": {
      "waiting": "В очереди",
      "uploading": "Загружается",
      "done": "Загружен",
      "failed": "Ошибка"
    },
    "showAllFiles_one": "Показать {{count}} файл",
    "showAllFiles_few": "Показать все {{count}} файла",
    "showAllFiles_many": "Показать все {{count}} файлов",
    "showAllFiles_other": "Показать все {{count}} файла",
    "unfinished": "Загружено {{uploaded}} из {{total}} медиафайлов",
    "unfinishedHelp": "Пакет сохранён, но никто не сможет начать с ним игру, пока не загружены все медиа. Догрузить можно сейчас или позже в разделе «Мои пакеты».",
    "resumeLater": "Догрузить позже",
    "uploadAnyway": "Всё равно загрузить",
    "duplicates": {
      "title_one": "Этот пакет уже есть в OpenQuester",
      "title_few": "Этот пакет уже есть в OpenQuester ({{count}} раза)",
      "title_many": "Этот пакет уже есть в OpenQuester ({{count}} раз)",
      "title_other": "Этот пакет уже есть в OpenQuester ({{count}} раза)",
      "help": "Его загрузили из того же файла. Используйте его вместо копии или загрузите ещё раз, если так и задумано.",
      "yours": "Ваша загрузка · {{when}}",
      "by": "От {{author}} · {{when}}",
      "resume": "Догрузить этот пакет",
      "open": "Открыть"
    },
    "htmlRemoval": {
      "title": "Неподдерживаемые HTML-вопросы",
      "explanation_one": "HTML-вопросы не поддерживаются. Для продолжения нужно удалить {{count}} вопрос. Исходный файл не изменится.",
      "explanation_few": "HTML-вопросы не поддерживаются. Для продолжения нужно удалить {{count}} вопроса. Исходный файл не изменится.",
      "explanation_many": "HTML-вопросы не поддерживаются. Для продолжения нужно удалить {{count}} вопросов. Исходный файл не изменится.",
      "explanation_other": "HTML-вопросы не поддерживаются. Для продолжения нужно удалить {{count}} вопроса. Исходный файл не изменится.",
      "all": "Вопросов не останется, поэтому этот файл нельзя импортировать.",
      "item": "{{round}} › {{theme}} › вопрос {{number}} › {{price}}",
      "cancel": "Отмена",
      "confirm": "Удалить и продолжить"
    },
    "includesMedia": "Изображения, аудио и видео из файла тоже загружаются."
  },
  "editor": {
    "storageFailed": "Не удалось обновить черновики на этом устройстве. Попробуйте ещё раз.",
    "drafts": "Черновики",
    "backToDrafts": "К черновикам",
    "cancel": "Отмена",
    "optional": "(необязательно)",
    "undo": "Отменить",
    "redo": "Повторить",
    "export": "Экспорт .oq",
    "exportHelp": "Скачать пакет как файл .oq, который можно открыть здесь или в приложении OpenQuester.",
    "savedAt": "Сохранено в этом браузере {{when}}",
    "notSaved": "Ещё не сохранено",
    "missing": "Этого черновика нет в этом браузере",
    "missingHelp": "Черновики хранятся в браузере, где их создали. Возможно, его удалили или создали на другом устройстве.",
    "seconds_one": "{{count}} сек.",
    "seconds_few": "{{count}} сек.",
    "seconds_many": "{{count}} сек.",
    "seconds_other": "{{count}} сек.",
    "secondsShort": "сек.",
    "player": {
      "play": "Воспроизвести",
      "pause": "Пауза",
      "seek": "Позиция воспроизведения",
      "mute": "Выключить звук",
      "unmute": "Включить звук",
      "volume": "Громкость",
      "fullscreen": "На весь экран",
      "fullscreenError": "Полноэкранный режим недоступен.",
      "exitFullscreen": "Выйти из полноэкранного режима",
      "loading": "Загрузка медиа…",
      "error": "Не удалось воспроизвести медиа."
    },
    "defaults": {
      "title": "Новый пакет",
      "round": "Раунд {{n}}",
      "theme": "Первая тема"
    },
    "home": {
      "title": "Редактор пакетов",
      "lead": "Соберите пакет с нуля или откройте файл .siq или .oq, а затем опубликуйте его для игры.",
      "newTitle": "С нуля",
      "newHelp": "Один раунд с темой на пять вопросов.",
      "new": "Новый пакет",
      "importTitle": "Открыть файл",
      "importHelp": "Пакет SIGame .siq или экспорт OpenQuester .oq. Редактируйте его здесь перед публикацией.",
      "import": "Открыть .siq или .oq",
      "drafts": "Ваши черновики",
      "draftsHelp": "Черновики хранятся в этом браузере до публикации. Экспортируйте .oq, чтобы перенести на другое устройство.",
      "noDrafts": "Черновиков пока нет.",
      "draftMeta": "Раундов: {{rounds}} · вопросов: {{questions}} · изменён {{when}}",
      "published": "опубликован",
      "deleteDraft": "Удалить черновик {{title}}",
      "deleteConfirm": "Удалить черновик «{{title}}»? Его медиа тоже удалятся из этого браузера."
    },
    "outline": {
      "label": "Структура пакета",
      "details": "О пакете",
      "rounds": "Раунды",
      "addRound": "Добавить раунд",
      "untitled": "Без названия",
      "counts": "Тем: {{themes}} · вопросов: {{questions}}"
    },
    "board": {
      "roundOf": "Раунд {{n}} из {{total}}",
      "roundName": "Название раунда",
      "roundNamePlaceholder": "Назовите раунд",
      "roundType": "Тип раунда",
      "roundTypes": {
        "simple": "Обычный",
        "final": "Финал"
      },
      "oneFinal": "В пакете один финальный раунд, и он уже есть.",
      "finalHelp": "В финале игроки выбирают тему, делают ставку и отвечают на один вопрос. В каждой теме ровно один вопрос без цены.",
      "addTheme": "Добавить тему",
      "roundActions": "Действия с раундом",
      "noThemes": "В этом раунде ещё нет тем",
      "noThemesHelp": "Тема — это строка на табло. Добавьте её, и в ней сразу будет пять вопросов для заполнения.",
      "themeName": "Название темы",
      "themeNamePlaceholder": "Назовите тему",
      "themeActions": "Действия с темой {{name}}",
      "dragTheme": "Перетащите, чтобы переместить тему в другое место или раунд",
      "questionCount_one": "{{count}} вопрос",
      "questionCount_few": "{{count}} вопроса",
      "questionCount_many": "{{count}} вопросов",
      "questionCount_other": "{{count}} вопроса",
      "questionActions": "Действия с {{label}}",
      "emptyQuestion": "Пустой вопрос",
      "noText": "Пока без текста",
      "addQuestion": "Добавить",
      "addQuestionTo": "Добавить вопрос в {{name}}",
      "dropHere": "Перетащите сюда",
      "needsFix": "Нужно исправить",
      "check": "Стоит проверить"
    },
    "actions": {
      "edit": "Редактировать",
      "move": "Переместить…",
      "moveTheme": "Переместить тему…",
      "duplicate": "Дублировать",
      "delete": "Удалить",
      "deleteTheme": "Удалить тему",
      "deleteRound": "Удалить раунд"
    },
    "density": {
      "label": "Вид табло",
      "compact": "Компактные карточки, вопрос при наведении",
      "cards": "Карточки с медиа и ответами"
    },
    "inspector": {
      "label": "Выбранный вопрос",
      "resize": "Изменить ширину панели вопроса"
    },
    "playtest": {
      "title": "Интерактивный просмотр игры",
      "description": "Локальная симуляция этого несохранённого вопроса. Настоящая игра не создаётся.",
      "loading": "Подготовка медиа вопроса…",
      "mediaError": "Не удалось загрузить медиа вопроса. Проверьте файлы и попробуйте снова.",
      "retry": "Попробовать снова",
      "fix": "Вернуться к редактированию",
      "invalid": "Этот вопрос ещё не завершён.",
      "perspective": "Смотреть как",
      "player": "Игрок {{number}}",
      "showman": "Ведущий",
      "spectator": "Зритель",
      "continue": "Продолжить",
      "restart": "Начать заново",
      "pause": "Пауза",
      "resume": "Продолжить игру",
      "controls": "Управление симуляцией",
      "local": "Локальная проверка черновика вопроса.",
      "settings": "Настройки проверки",
      "waiting": "Дождитесь сигнала или ускорьте показ содержимого.",
      "legacy": "Просмотр использует текущие размеры изображения. Сохранённый старый вопрос сохранит прежнюю логику сервера до повторной публикации.",
      "theme": "Тестовая тема",
      "round": "Тестовый раунд",
      "final": "Финальный раунд",
      "number": "Число",
      "deviation": "Допустимое отклонение ответа должно быть не меньше нуля.",
      "stakeLimit": "Максимальная ставка для этого аукциона должна быть не меньше цены вопроса.",
      "keepTheme": "Останется для проверки",
      "targetTheme": "Тема «{{name}}» оставлена для проверяемого вопроса.",
      "finished": "Проверка завершена. Начните заново, чтобы повторить.",
      "switchToPlayer": "Переключите просмотр на игрока, который может действовать.",
      "judgeAnswers": "Оцените отправленные ответы с помощью элементов управления ниже.",
      "switchToShowman": "Переключитесь на ведущего, чтобы оценить отправленные ответы."
    },
    "preview": {
      "mediaCount": "Медиафайлов: {{count}}",
      "mediaOnly": "Ответ в медиа",
      "openFull": "Выберите вопрос для полного просмотра.",
      "answer": "Ответ",
      "pointAnswer": "Точка на изображении",
      "pointUnavailable": "Точка или её изображение недоступны.",
      "noAnswer": "Ответа пока нет",
      "noQuestion": "Пока нет текста или медиа",
      "hint": "Подсказка ведущему",
      "comment": "Комментарий",
      "maxBid": "Ставки до {{max}}",
      "allIn": "Можно ва-банк",
      "everyone": "играют все",
      "back": "Назад",
      "readOnly": "Просмотр · раундов: {{rounds}} · вопросов: {{questions}} · только чтение"
    },
    "media": {
      "dragFile": "Перетащить файл {{number}}, чтобы изменить порядок",
      "moveEarlier": "Переместить файл {{number}} раньше",
      "moveLater": "Переместить файл {{number}} позже",
      "pointUndoConfirm": "Отмена изменит изображение для правильной точки. Текущая точка будет сброшена. Продолжить?",
      "sizeUnknown": "Размер неизвестен",
      "image": "Изображение",
      "audio": "Аудио",
      "video": "Видео",
      "missing": "Файла нет",
      "add": "Добавить изображение, аудио или видео",
      "reading": "Читаем…",
      "remove": "Убрать файл",
      "show": "Показ",
      "dropMore": "Перетащите сюда ещё файлы",
      "errors": {
        "mediaType": "{{name}} — не изображение, аудио или видео.",
        "mediaSize": "{{name}} больше 100 МБ."
      }
    },
    "form": {
      "title": "Вопрос за {{price}}",
      "finalTitle": "Финальный вопрос",
      "description": "Редактируйте вопрос, ответ и медиа.",
      "type": "Тип вопроса",
      "typeHelp": {
        "simple": "Отвечает первый нажавший",
        "stake": "Игроки торгуются за право ответа",
        "secret": "Передаётся другому игроку",
        "noRisk": "Без штрафа, бонусные очки",
        "choice": "Выбор из вариантов",
        "hidden": "Цена скрыта на табло"
      },
      "price": "Цена",
      "text": "Текст вопроса",
      "textPlaceholder": "Что видят игроки и читает ведущий",
      "questionMedia": "Показывается с вопросом",
      "questionMediaHelp": "Перетащите сюда изображения, аудио или видео. Вопросу нужен текст или медиа.",
      "textFirst": "Сначала текст, затем каждый файл по очереди",
      "answer": "Правильные ответы",
      "answerHelp": "<strong>Каждый допустимый ответ — с новой строки.</strong> Игроки увидят их после оценки ответа.",
      "hint": "Подсказка ведущему",
      "hintHelp": "Видит только ведущий, чтобы оценивать близкие ответы.",
      "answerMedia": "Показывается с ответом",
      "answerMediaHelp": "Необязательные медиа, которые появляются вместе с ответом.",
      "comment": "Комментарий",
      "commentHelp": "Инструкция ведущему перед чтением вопроса.",
      "options": "Варианты",
      "optionsHelp": "От двух до восьми вариантов. Отметьте правильный.",
      "option": "Вариант {{letter}}",
      "correct": "Правильный",
      "removeOption": "Убрать вариант {{letter}}",
      "addOption": "Добавить вариант",
      "settingsFor": "Настройки: {{type}}",
      "maxBid": "Наибольшая ставка",
      "maxBidHelp": "Оставьте пустым, чтобы разрешить ва-банк.",
      "stakeEveryone": "Все делают ставку и отвечают",
      "multiplier": "Множитель цены",
      "noRiskEveryone": "Играют все",
      "transferTitle": "Кому можно передать",
      "transfer": {
        "any": "Любому игроку",
        "exceptCurrent": "Любому, кроме выбиравшего"
      },
      "allowedPrices": "Цены на выбор получателя",
      "allowedPricesHelp": "Необязательно: от 2 до 5 цен через запятую. Пусто — цена с табло.",
      "showDelay": "Варианты появляются через (сек.)",
      "showAnswer": "Длительность показа ответа",
      "secondsUnit": "секунд",
      "revealRange": "Введите длительность от 2 до 30 секунд.",
      "revealMediaHelp": "Длительность определяет медиа ответа; это резервное значение не применяется.",
      "preview": "Предпросмотр",
      "save": "Сохранить",
      "saveShortcut": "Ctrl+Enter сохраняет",
      "unsaved": "В этом вопросе есть несохранённые изменения.",
      "discard": "Отбросить изменения",
      "keepEditing": "Продолжить",
      "rightAnswers": "Также засчитывать",
      "rightAnswersHelp": "<strong>Каждый ответ — с новой строки.</strong> Вариант, совпадающий с любым из этих ответов, также считается правильным.",
      "wrongAnswers": "Неверные ответы",
      "wrongAnswersHelp": "<strong>По одному в строке.</strong> Частые ошибки, чтобы ведущему было проще оценивать. Игроки их не видят.",
      "authors": "Авторы",
      "sources": "Источники",
      "sourcesHelp": "По одному в строке: ссылки или книги. Показываются вместе с ответом.",
      "answerType": "Как отвечают игроки",
      "answerTypes": {
        "text": "Текст",
        "number": "Число",
        "point": "Точка на изображении"
      },
      "answerTypeHelp": {
        "text": "Ответ оценивает ведущий.",
        "number": "Число проверяется автоматически.",
        "point": "Точка на изображении проверяется автоматически."
      },
      "answerNumber": "Верное число",
      "answerNumberMissing": "Укажите верное число",
      "deviation": "Допустимая разница",
      "deviationHelp": "0 — только это число.",
      "pointHelp": "Нажмите на верное место на выбранной картинке.",
      "radius": "Радиус ответа",
      "radiusLoading": "Загрузка размеров изображения…",
      "radiusValue": "{{percent}}% · радиус {{pixels}} пикс.",
      "radiusLegacy": "Этот радиус превышает диапазон ползунка. Он останется прежним, пока вы его не измените.",
      "pointLegacy": "Эта опубликованная точка использует старую проверку до повторной публикации через веб-редактор.",
      "pointNeedsImage": "Сначала добавьте картинку к вопросу."
    },
    "timeline": {
      "add": "Добавить текстовый шаг",
      "text": "Дополнительный текст {{number}}",
      "earlier": "Переместить шаг {{number}} раньше",
      "later": "Переместить шаг {{number}} позже",
      "remove": "Удалить текстовый шаг {{number}}",
      "mainFirstHelp": "Показывается первым, перед медиа и другими текстовыми шагами.",
      "moveHandle": "Перетащите для изменения порядка или используйте клавиши со стрелками",
      "moveStatus": "Перемещено на позицию {{number}}"
    },
    "move": {
      "questionTitle": "Переместить вопрос",
      "themeTitle": "Переместить тему",
      "round": "Раунд",
      "theme": "Тема",
      "noThemes": "В этом раунде ещё нет тем.",
      "position": "Место",
      "atEnd": "В конец",
      "before": "Перед {{name}}",
      "confirm": "Переместить сюда"
    },
    "details": {
      "title": "О пакете",
      "name": "Название пакета",
      "namePlaceholder": "Назовите пакет",
      "description": "Описание",
      "language": "Язык",
      "noLanguage": "Не указан",
      "age": "Возрастное ограничение",
      "tags": "Теги",
      "tagsPlaceholder": "кино, музыка, 90-е",
      "tagsHelp": "Разделяйте теги запятыми. Они помогают найти ваш пакет.",
      "authorsHelp": "По одному в строке. Показываются на странице пакета."
    },
    "confirm": {
      "themeTitle": "Удалить тему?",
      "roundTitle": "Удалить раунд?",
      "themeBody_one": "«{{name}}» и {{count}} вопрос в ней будут удалены. Это можно отменить.",
      "themeBody_few": "«{{name}}» и {{count}} вопроса в ней будут удалены. Это можно отменить.",
      "themeBody_many": "«{{name}}» и {{count}} вопросов в ней будут удалены. Это можно отменить.",
      "themeBody_other": "«{{name}}» и {{count}} вопроса в ней будут удалены. Это можно отменить.",
      "roundBody_one": "«{{name}}» со всеми темами и {{count}} вопросом будет удалён. Это можно отменить.",
      "roundBody_few": "«{{name}}» со всеми темами и {{count}} вопросами будет удалён. Это можно отменить.",
      "roundBody_many": "«{{name}}» со всеми темами и {{count}} вопросами будет удалён. Это можно отменить.",
      "roundBody_other": "«{{name}}» со всеми темами и {{count}} вопросами будет удалён. Это можно отменить."
    },
    "changes": {
      "renamed": "Переименовано",
      "questionSaved": "Вопрос сохранён",
      "questionAdded": "Вопрос добавлен",
      "questionMoved": "Перемещено в {{to}}",
      "questionDeleted": "Вопрос удалён",
      "themeAdded": "Тема добавлена",
      "themeMoved": "Тема перемещена в {{to}}",
      "themeDeleted": "Тема удалена",
      "roundAdded": "Раунд добавлен",
      "roundMoved": "Раунд перемещён",
      "roundDeleted": "Раунд удалён",
      "roundType": "Тип раунда изменён",
      "duplicated": "Продублировано",
      "detailsSaved": "Сохранено",
      "pricesSet": "Цены заданы",
      "questionsPasted": "Вопросы добавлены"
    },
    "empty": {
      "title": "Пустой пакет",
      "help": "Добавьте раунд, чтобы начать. В раунде темы, в теме вопросы."
    },
    "health": {
      "good": "Готово к публикации",
      "needsAttention": "Можно публиковать, но кое-что стоит проверить",
      "broken_one": "{{count}} проблема, которую нужно исправить перед публикацией",
      "broken_few": "{{count}} проблемы, которые нужно исправить перед публикацией",
      "broken_many": "{{count}} проблем, которые нужно исправить перед публикацией",
      "broken_other": "{{count}} проблемы, которые нужно исправить перед публикацией"
    },
    "severity": {
      "critical": "Нужно исправить ({{count}})",
      "warning": "Стоит проверить ({{count}})",
      "info": "Советы ({{count}})"
    },
    "status": {
      "good_one": "Готово к публикации · {{count}} вопрос",
      "good_few": "Готово к публикации · {{count}} вопроса",
      "good_many": "Готово к публикации · {{count}} вопросов",
      "good_other": "Готово к публикации · {{count}} вопроса",
      "review": "Проверить"
    },
    "publish": {
      "open": "Опубликовать",
      "title": "Публикация пакета",
      "publish": "Опубликовать в OpenQuester",
      "help": "Публикация загружает пакет и медиа, чтобы вы могли проводить с ним игры.",
      "blocked_one": "Сначала исправьте проблему выше. Нажмите на неё, чтобы перейти.",
      "blocked_few": "Сначала исправьте {{count}} проблемы выше. Нажмите на любую, чтобы перейти.",
      "blocked_many": "Сначала исправьте {{count}} проблем выше. Нажмите на любую, чтобы перейти.",
      "blocked_other": "Сначала исправьте {{count}} проблемы выше. Нажмите на любую, чтобы перейти.",
      "sending": "Загрузка медиа {{done}} из {{total}}",
      "doneHelp": "Запустите игру с ним сейчас или найдите его позже в «Пакетах». Черновик остаётся здесь для правок; повторная публикация обновляет этот пакет (можно также опубликовать его как новый).",
      "saveChanges": "Сохранить изменения в опубликованном пакете",
      "publishAsNew": "Опубликовать как новый пакет",
      "notYours": "Изменять пакет может только его автор. Опубликуйте его как новый пакет."
    },
    "issues": {
      "noTitle": "У пакета нет названия.",
      "noRounds": "В пакете нет раундов.",
      "roundNoName": "У раунда нет названия.",
      "roundNoThemes": "В раунде нет тем.",
      "themeNoName": "У темы нет названия.",
      "themeNoQuestions": "В теме нет вопросов.",
      "questionEmpty": "У вопроса нет текста или медиа.",
      "noPrice": "У вопроса нет цены.",
      "priceRange": "Цена должна быть от 0 до {{max}}.",
      "missingMedia": "Медиафайла нет в этом браузере. Добавьте его снова.",
      "choiceOptions": "Вопросу с выбором нужно от 2 до 8 вариантов (сейчас {{count}}).",
      "choiceEmptyOption": "У одного из вариантов нет текста.",
      "choiceNoCorrect": "Ни один вариант не отмечен как правильный.",
      "choiceCorrectUnresolved": "Выберите правильный вариант снова перед публикацией.",
      "secretPrices": "Укажите от 2 до 5 цен для получателя или оставьте список пустым (сейчас {{count}}).",
      "multipleFinals": "Финальным может быть только один раунд.",
      "finalNotLast": "Финальный раунд должен быть последним.",
      "finalOneQuestion": "В финальной теме ровно один вопрос (сейчас {{count}}).",
      "finalTypeIgnored": "Финальные вопросы всегда обычные; тип игнорируется.",
      "noAnswer": "У вопроса нет ответа. Ведущий будет оценивать без него.",
      "longText": "Текст очень длинный и может не поместиться на экране.",
      "noLanguage": "Укажите язык, чтобы игрокам было проще найти пакет.",
      "noDescription": "Добавьте короткое описание.",
      "noTags": "Добавьте несколько тегов.",
      "numberAnswerMissing": "Ответ-число без правильного числа",
      "pointAnswerMissing": "Ответ-точка без изображения или правильного места"
    },
    "tools": {
      "pricesTitle": "Задать цены в раунде",
      "pricesHelp": "У всех тем раунда будут одинаковые цены, начиная с первой.",
      "firstPrice": "Первая цена",
      "step": "Шаг",
      "pricesPreview": "Цены: {{prices}}…",
      "applyPrices": "Задать цены",
      "pasteTitle": "Вставить вопросы текстом",
      "pasteHelp": "Каждый блок — тема: название в первой строке, затем по вопросу в строке, ответ после «|» или « — ». Пустая строка начинает следующую тему. Число в начале строки — цена.",
      "pasteLabel": "Вопросы",
      "pastePlaceholder": "Столицы\n100. Столица Франции? | Париж\n200. Столица Японии? | Токио\n\nПланеты\n100. Красная планета? | Марс",
      "pasteSummary": "Тем: {{themes}}, вопросов: {{questions}}.",
      "pasteMissing_one": "У {{count}} вопроса пока нет ответа.",
      "pasteMissing_few": "У {{count}} вопросов пока нет ответа.",
      "pasteMissing_many": "У {{count}} вопросов пока нет ответа.",
      "pasteMissing_other": "У {{count}} вопросов пока нет ответа.",
      "pasteAdd": "Добавить в раунд",
      "searchTitle": "Поиск по пакету",
      "searchPlaceholder": "Вопрос, ответ или тема",
      "searchCount_one": "Найден {{count}} вопрос",
      "searchCount_few": "Найдено {{count}} вопроса",
      "searchCount_many": "Найдено {{count}} вопросов",
      "searchCount_other": "Найдено {{count}} вопросов",
      "noText": "(без текста)"
    },
    "saveFailed": "Изменения не сохранены на этом устройстве (возможно, хранилище заполнено). Они остаются в этой вкладке: повторите или экспортируйте файл.",
    "saveRetry": "Сохранить ещё раз",
    "importReportHide": "Скрыть отчёт",
    "exportMediaFailed": "Не удалось экспортировать: файл {{name}} не загрузился из хранилища. Проверьте соединение и попробуйте ещё раз."
  },
  "panels": {
    "pin": "Закрепить: {{name}}",
    "unpin": "Открепить: {{name}}",
    "close": "Закрыть: {{name}}",
    "pinHelp": "Держать панель открытой рядом с игрой, даже после перезагрузки",
    "unpinHelp": "Закреплено на этом устройстве. Нажмите, чтобы открепить"
  },
  "adminPanel": {
    "title": "Админка",
    "overview": "Обзор",
    "users": "Пользователи",
    "system": "Система",
    "noAccess": "Эта страница только для администраторов.",
    "noAccessHelp": "У вашего аккаунта нет доступа администратора. Попросите администратора, если он нужен.",
    "loadFailed": "Не удалось загрузить. Попробуйте снова.",
    "totalUsers": "Пользователи",
    "activeUsers": "Активные",
    "guests": "Гости",
    "deletedUsers": "Удалённые",
    "bannedUsers": "Заблокированные",
    "uptime": "Время работы сервера",
    "redis": "Redis",
    "redisKeys_one": "{{count}} ключ",
    "redisKeys_few": "{{count}} ключа",
    "redisKeys_many": "{{count}} ключей",
    "redisKeys_other": "{{count}} ключа",
    "down": "Не работает",
    "recentUsers": "Новые пользователи",
    "guest": "Гость",
    "search": "Поиск по имени, логину или email",
    "status": "Статус",
    "anyStatus": "Любой",
    "statusActive": "Активен",
    "statusBanned": "Заблокирован",
    "statusDeleted": "Удалён",
    "type": "Тип",
    "typeAll": "Все",
    "typeRegistered": "Зарегистрированные",
    "typeGuest": "Гости",
    "actionFailed": "Не получилось. Попробуйте снова.",
    "noUsers": "Никого не найдено.",
    "mutedUntil": "Без чата до {{date}}",
    "mute": "Отключить чат…",
    "unmute": "Включить чат",
    "forHours_one": "На {{count}} час",
    "forHours_few": "На {{count}} часа",
    "forHours_many": "На {{count}} часов",
    "forHours_other": "На {{count}} часа",
    "forWeek": "На неделю",
    "ban": "Заблокировать",
    "unban": "Разблокировать",
    "confirmBan": "Подтвердить блокировку",
    "delete": "Удалить",
    "confirmDelete": "Подтвердить удаление",
    "restore": "Восстановить",
    "noHealthAccess": "Ваш аккаунт не может смотреть состояние системы.",
    "ping": "API",
    "ok": "OK",
    "eventLoop": "Задержка event loop",
    "redisMemory": "Память Redis",
    "redisKeysLabel": "Ключи Redis",
    "memory": "Память сервера",
    "refresh": "Обновить",
    "packages": "Пакеты",
    "games": "Игры",
    "role": "Роль",
    "roleUser": "Пользователь",
    "roleModerator": "Модератор",
    "roleAdmin": "Администратор",
    "roleHelp": {
      "user": "Без доступа к админ-панели.",
      "moderator": "Модерирует людей, игры и пакеты. При необходимости отметь дополнительные права ниже.",
      "admin": "Всё, включая роли и права."
    },
    "permissions": "Права",
    "perm": {
      "get_all_users": "Видеть список пользователей",
      "get_another_user": "Видеть любой профиль",
      "change_another_user": "Редактировать любой профиль",
      "delete_another_user": "Удалять и восстанавливать аккаунты",
      "delete_file": "Удалять загруженные файлы",
      "delete_package": "Удалять любой пакет",
      "edit_package": "Редактировать любой пакет",
      "manage_permissions": "Менять роли и права",
      "admin_panel_access": "Открывать админ-панель",
      "view_system_health": "Видеть состояние сервера",
      "view_users_info": "Видеть данные и статистику пользователей",
      "ban_users": "Банить и разбанивать",
      "mute_player": "Отключать и включать чат",
      "manage_games": "Модерировать игры (удалять людей, пауза, закрытие)",
      "view_system_logs": "Читать логи сервера",
      "manage_storage": "Менять лимиты хранилища"
    },
    "savePermissions": "Сохранить",
    "editRole": "Роль…",
    "gameSearch": "Поиск игр по названию",
    "noGames": "Сейчас игр нет.",
    "gameFinished": "Завершена",
    "gamePaused": "На паузе",
    "playersCount": "{{count}}/{{max}} игроков",
    "manage": "Управлять",
    "gameGone": "Эта игра закончилась или её закрыли.",
    "packageName": "Пакет: {{title}}",
    "nobodyInGame": "В этой игре никого нет.",
    "people": "Люди в этой игре",
    "resume": "Продолжить",
    "pause": "Пауза",
    "openGame": "Открыть игру",
    "closeGame": "Закрыть игру",
    "confirmCloseGame": "Подтвердить: закрыть для всех",
    "closeGameHelp": "Всех в игре вернёт на главную, а игра будет удалена.",
    "offline": "Вышел или не в сети",
    "remove": "Удалить",
    "confirmRemove": "Подтвердить удаление",
    "removeNamed": "Удалить {{name}}",
    "noPackages": "Пакетов не найдено.",
    "byAuthor": "автор {{name}}",
    "packageSize": "раундов: {{rounds}}, вопросов: {{questions}}",
    "edit": "Редактировать",
    "deleteNamed": "Удалить {{name}}",
    "storage": "Хранилище"
  },
  "myPackages": {
    "title": "Мои пакеты",
    "guest": "Гостевые аккаунты не могут владеть пакетами. Войдите через Discord, чтобы публиковать и управлять своими.",
    "empty": "Вы ещё не опубликовали ни одного пакета. Создайте его в редакторе или загрузите файл .siq или .oq.",
    "published": "опубликован {{when}}",
    "host": "Провести",
    "edit": "Редактировать",
    "opening": "Открываем…",
    "delete": "Удалить",
    "confirmDelete": "Да, удалить",
    "deleteHelp": "Удаление убирает пакет для всех. Уже идущие игры сохраняют свою копию.",
    "deleteFailed": "Не удалось удалить пакет. Попробуйте снова.",
    "openFailed": "Не удалось открыть пакет в редакторе. Попробуйте снова.",
    "link": "Мои пакеты"
  },
  "storage": {
    "loadFailed": "Не удалось загрузить использование хранилища.",
    "title": "Хранилище",
    "used": "Использовано {{used}} из {{quota}}",
    "usedNoLimit": "Использовано {{used}}, без ограничения",
    "almostFull": "Вы почти достигли лимита. Включите сжатие медиа или удалите ненужные пакеты.",
    "full": "Вы достигли лимита. Удалите ненужные пакеты или попросите администратора о большем месте.",
    "bucket": "Всё хранилище",
    "bucketFiles_one": "{{count}} сохранённый файл",
    "bucketFiles_few": "{{count}} сохранённых файла",
    "bucketFiles_many": "{{count}} сохранённых файлов",
    "bucketFiles_other": "{{count}} сохранённых файлов",
    "groupsTitle": "Лимиты по группам",
    "groupsHelp": "В мегабайтах; оставьте поле пустым, чтобы не ограничивать. Файл, которым пользуются несколько человек, считается для каждого, а хранилище держит одну копию.",
    "usersTitle": "Кто использует больше всего",
    "noUsers": "Пока никто ничего не сохранил.",
    "noLimit": "Без лимита",
    "save": "Сохранить",
    "saved": "Сохранено",
    "ownQuota": "Свой лимит",
    "ownQuotaLabel": "Лимит хранилища для {{name}}",
    "groupDefault": "Лимит группы",
    "groups": {
      "guest": "Гости",
      "user": "Игроки",
      "moderator": "Модераторы",
      "admin": "Администраторы"
    },
    "fields": {
      "userQuotaBytes": "Всего на человека",
      "packageBytes": "Один пакет",
      "imageBytes": "Одно изображение",
      "audioBytes": "Один аудиофайл",
      "videoBytes": "Одно видео"
    },
    "projected": "Этот пак: примерно +{{size}}.",
    "projectedOverQuota": "Пак может потребовать ещё {{size}} и превысить лимит. Доступное место будет проверено при загрузке.",
    "projectedUsage": "Уже занято {{used}}; этот пак может добавить {{pending}}."
  },
  "allPlay": {
    "kickerStake": "Ставка для всех",
    "kickerNoRisk": "Без риска для всех",
    "ruleStake": "Все делают ставку и пишут ответ. Верно — выигрываете ставку, неверно — теряете. Ставка до {{max}}.",
    "ruleNoRisk": "Все пишут ответ. Верно — {{points}}, неверно — без потерь.",
    "stakePrompt": "Сделайте ставку — её никто не увидит, пока не придут ответы",
    "players": "Игроки"
  },
  "point": {
    "pick": "Нажмите, где ответ",
    "picture": "Картинка вопроса",
    "pictureWaiting": "Подождите, пока появится нужная картинка.",
    "pictureUnavailable": "Нужная картинка недоступна. Попросите ведущего пропустить ответ.",
    "prompt": "Нажмите на нужное место на картинке",
    "cursor": "Курсор: {{x}}% слева, {{y}}% сверху. Стрелки двигают его, Enter выбирает.",
    "pickedDescription": "Ваша отметка: {{x}}% ширины изображения слева, {{y}}% высоты сверху.",
    "answerDescription": "{{name}} выбрал точку: {{x}}% ширины изображения слева, {{y}}% высоты сверху.",
    "finalPictureUnavailable": "Изображение для ответа недоступно. Отправить ответ точкой невозможно.",
    "targetDescription": "Правильная точка: {{x}}% ширины изображения слева, {{y}}% его высоты сверху. Радиус допуска: {{radius}}% ширины изображения.",
    "imageDimensions": "Размеры изображения: {{width}} на {{height}} пикселей.",
    "imageDimensionsUnavailable": "Размеры изображения пока недоступны."
  },
  "stats": {
    "title": "Ваши игры",
    "seeLeaderboard": "Открыть рейтинг",
    "loadFailed": "Не удалось загрузить статистику.",
    "noGames": "Доиграйте игру как игрок, и результаты появятся здесь.",
    "games": "Игры",
    "wins": "Победы",
    "totalScore": "Всего очков",
    "bestScore": "Лучшая игра",
    "accuracy": "Верные ответы",
    "answers": "Всего верных ответов: {{right}}, неверных: {{wrong}}.",
    "recent": "Последние игры",
    "won": "Победа",
    "place": "Место {{place}} из {{players}}",
    "played": "Сыграно"
  },
  "leaderboard": {
    "title": "Рейтинг",
    "help": "Игроки по числу побед, затем по сумме очков. Гостевые аккаунты не показываются.",
    "period": "Период",
    "periods": {
      "week": "За неделю",
      "month": "За месяц",
      "all": "За всё время"
    },
    "loadFailed": "Не удалось загрузить рейтинг.",
    "empty": "За этот период ещё никто не доиграл игру.",
    "player": "Игрок",
    "you": "вы"
  },
  "report": {
    "open": "С вопросом что-то не так?",
    "title": "Пожаловаться на вопрос",
    "help": "Автор пакета увидит вашу заметку и сможет исправить вопрос.",
    "reason": "Что не так?",
    "reasons": {
      "wrong_answer": "Неверный ответ",
      "broken_media": "Не работает картинка, звук или видео",
      "offensive": "Оскорбительный вопрос",
      "other": "Другое"
    },
    "comment": "Подробности (необязательно)",
    "commentPlaceholder": "Например, верный ответ и источник",
    "send": "Отправить",
    "sent": "Спасибо, автор увидит вашу жалобу.",
    "already": "Вы уже пожаловались на этот вопрос.",
    "failed": "Не удалось отправить жалобу. Попробуйте ещё раз."
  },
  "reports": {
    "short": "Жалобы",
    "button": "Жалобы, открытых: {{n}}",
    "title": "Жалобы на «{{title}}»",
    "help": "Что отметили игроки во время игр. Исправьте вопрос в редакторе и отметьте жалобу решённой.",
    "noText": "Вопрос без текста",
    "resolve": "Решено",
    "reopen": "Открыть снова"
  },
  "resume": {
    "title": "Завершить загрузку",
    "notYours": "Завершить загрузку может только автор пакета.",
    "notFound": "Этого пакета больше нет.",
    "done": "Все медиа загружены",
    "doneHelp_one": "Его {{count}} медиафайл в хранилище, так что пакет готов к игре.",
    "doneHelp_few": "Все {{count}} медиафайла в хранилище, так что пакет готов к игре.",
    "doneHelp_many": "Все {{count}} медиафайлов в хранилище, так что пакет готов к игре.",
    "doneHelp_other": "Все {{count}} медиафайла в хранилище, так что пакет готов к игре.",
    "notInFile_one": "{{count}} недостающего файла нет в выбранном файле. Выберите файл, из которого загружали этот пакет.",
    "notInFile_few": "{{count}} недостающих файлов нет в выбранном файле. Выберите файл, из которого загружали этот пакет.",
    "notInFile_many": "{{count}} недостающих файлов нет в выбранном файле. Выберите файл, из которого загружали этот пакет.",
    "notInFile_other": "{{count}} недостающего файла нет в выбранном файле. Выберите файл, из которого загружали этот пакет.",
    "otherPackage": "Вы выбрали «{{picked}}», а это «{{title}}». Выберите файл, из которого загружали этот пакет.",
    "stashAll_one": "В этом браузере ещё сохранился недостающий файл с первой попытки.",
    "stashAll_few": "В этом браузере ещё сохранились все {{count}} недостающих файла с первой попытки.",
    "stashAll_many": "В этом браузере ещё сохранились все {{count}} недостающих файлов с первой попытки.",
    "stashAll_other": "В этом браузере ещё сохранились все {{count}} недостающих файла с первой попытки.",
    "stashSome": "В этом браузере ещё есть {{count}} из {{total}} недостающих файлов с первой попытки. Загрузите их сейчас, а для остальных выберите файл пакета.",
    "uploadStashed_one": "Загрузить {{count}} файл",
    "uploadStashed_few": "Загрузить {{count}} файла",
    "uploadStashed_many": "Загрузить {{count}} файлов",
    "uploadStashed_other": "Загрузить {{count}} файла",
    "pickHelp": "Выберите тот же файл .siq или .oq ещё раз. Загрузятся только недостающие медиа."
  },
  "roundTransition": {
    "title": "Следующий раунд",
    "description": "Раунд {{n}} — {{name}}",
    "firstTitle": "Первый раунд"
  },
  "skipRound": {
    "title": "Перейти к следующему раунду?",
    "help_one": "На поле ещё {{count}} вопрос. Его не сыграют.",
    "help_few": "На поле ещё {{count}} вопроса. Их не сыграют.",
    "help_many": "На поле ещё {{count}} вопросов. Их не сыграют.",
    "help_other": "На поле ещё {{count}} вопроса. Их не сыграют.",
    "helpEmpty": "Следующий раунд начнётся сразу.",
    "confirm": "Пропустить раунд"
  },
  "discordActivity": {
    "connecting": "Подключение к Discord…",
    "findingGame": "Ищем игру этого звонка…",
    "retry": "Попробовать снова",
    "pickTitle": "Выберите пакет для этого звонка",
    "pickHint": "Кто выберет первым, тот ведёт игру. Остальные участники звонка присоединятся автоматически.",
    "search": "Поиск пакетов",
    "noPackages": "Пакеты не найдены.",
    "gameReady": "{{host}} ведёт игру этого звонка.",
    "joinGame": "Присоединиться к игре",
    "errors": {
      "not_configured": "Этот сервер не настроен для работы как Discord Activity.",
      "auth_failed": "Не удалось войти через Discord на шаге: {{step}}",
      "timeout": "Discord не ответил на шаге: {{step}}",
      "settings": "Не удалось связаться с сервером OpenQuester."
    },
    "steps": {
      "handshake": "Подключение к Discord…",
      "authorize": "Ждём разрешения Discord…",
      "sign_in": "Вход в OpenQuester…",
      "authenticate": "Завершаем вход через Discord…"
    },
    "rejoinGame": "Вернуться в игру",
    "otherGames": "Другие игры",
    "gameCode": "Код или ссылка на игру",
    "joinByCode": "Присоединиться",
    "noOtherGames": "Сейчас нет других открытых игр.",
    "presence": {
      "lobby": "В лобби",
      "paused": "Пауза",
      "round": "{{round}}",
      "finished": "Игра окончена",
      "lobbyDetails": "Викторина OpenQuester",
      "choosing": "Выбирает игру"
    }
  },
  "mediaEditor": {
    "title": "Редактирование медиа",
    "edit": "Редактировать",
    "loading": "Подготовка медиа…",
    "queue": "Файл {{index}} из {{total}}",
    "cancelProcessing": "Отменить обработку",
    "processing": "Обработка медиа…",
    "retry": "Повторить",
    "discardPrompt": "Отменить эти изменения медиа?",
    "skip": "Пропустить файл",
    "remaining": "Добавить остальные без изменений",
    "unchanged": "Использовать без изменений",
    "save": "Сохранить медиа",
    "saveQuestion": "Сохранить вопрос",
    "saveDetails": "Сохранить данные пакета",
    "saveNext": "Сохранить и далее",
    "imageTools": "Инструменты изображения",
    "select": "Выбрать / переместить",
    "pen": "Перо",
    "arrow": "Стрелка",
    "rectangle": "Прямоугольник",
    "text": "Текст",
    "blur": "Размыть область",
    "undo": "Отменить изменение медиа",
    "redo": "Повторить изменение",
    "canvas": "Предпросмотр. Рисуйте инструментами панели; выберите отметку и перемещайте клавишами со стрелками.",
    "fit": "Вписать в окно",
    "compare": "Удерживайте для оригинала",
    "updating": "Обновление итогового предпросмотра…",
    "rotateLeft": "Повернуть влево",
    "rotateRight": "Повернуть вправо",
    "wholeBlur": "Размытие всего изображения",
    "quality": "Качество результата",
    "small": "Маленький файл",
    "balanced": "Сбалансированное",
    "high": "Высокое качество",
    "color": "Цвет рисования",
    "textSize": "Размер текста",
    "strength": "Сила размытия",
    "stroke": "Толщина линии",
    "annotation": "Выбранная отметка",
    "delete": "Удалить отметку",
    "waveform": "Звуковая волна",
    "start": "Начало",
    "end": "Конец",
    "position": "Позиция воспроизведения",
    "pause": "Приостановить предпросмотр",
    "duration": "Результат: {{duration}}",
    "removeAudio": "Удалить звук",
    "noAudio": "В этом видео нет звука",
    "fadeIn": "Плавное начало",
    "fadeOut": "Плавное завершение",
    "fadeInSeconds": "Длительность плавного начала в секундах",
    "fadeOutSeconds": "Длительность плавного завершения в секундах",
    "visualUnavailable": "Предпросмотр временной шкалы недоступен. Можно использовать поля времени.",
    "choiceImage": "Изображение варианта {{letter}}",
    "logo": "Изображение пакета",
    "errors": {
      "mediaSize": "Файл превышает лимит редактора 100 МБ.",
      "mediaType": "Выберите изображение, аудио или видео, поддерживаемое этим полем.",
      "unsupported": "Этот браузер не может обработать выбранные дорожки. Попробуйте Chrome или Edge на компьютере либо используйте файл без изменений.",
      "unsupportedImage": "Это изображение или браузер не поддерживает редактирование. Анимированные изображения и SVG остаются без изменений.",
      "blurUnsupported": "Размытие недоступно в этом браузере.",
      "downloadFailed": "Не удалось скачать исходный файл из хранилища. Проверьте подключение и повторите попытку; вложение не изменено.",
      "downloadCorrupt": "Скачанный файл не совпадает с файлом в паке. Повторите попытку; вложение не изменено.",
      "processingFailed": "Не удалось обработать медиа. Ваши изменения остаются в редакторе; повторите попытку или используйте файл без изменений.",
      "trim": "Начало должно быть раньше конца и в пределах файла. Формат — минуты:секунды (например, 01:23.50)."
    },
    "zoom": "Масштаб просмотра",
    "zoomIn": "Увеличить",
    "zoomOut": "Уменьшить",
    "actualSize": "Показать в масштабе 100%",
    "crop": "Обрезать",
    "cropHelp": "Выделите область, которую хотите оставить, и примените обрезку. Ниже — проценты от исходного изображения.",
    "cropx": "Слева (%)",
    "cropy": "Сверху (%)",
    "cropwidth": "Ширина (%)",
    "cropheight": "Высота (%)",
    "applyCrop": "Применить обрезку",
    "resetCrop": "Сбросить обрезку",
    "trimTitle": "Оставить фрагмент",
    "trimHelp": "Выберите точку на таймлайне и обрежьте всё слева или справа от неё. Точное время можно изменить ниже.",
    "startTime": "Начало (мин:сек)",
    "endTime": "Конец (мин:сек)",
    "secondsUnit": "с",
    "fadeHelp": "Эффект может длиться весь фрагмент. Увеличение одного при необходимости сокращает другой.",
    "play": "Воспроизвести",
    "playbackTools": "Воспроизведение и обрезка",
    "trimLeft": "Обрезать всё слева от курсора",
    "trimRight": "Обрезать всё справа от курсора",
    "timelineHelp": "Нажмите или потяните по таймлайну для перемотки. Стрелки двигают курсор; пробел включает или останавливает воспроизведение.",
    "rotation": "Поворот (градусы)",
    "restoreAudio": "Вернуть звук",
    "fadeEnvelope": "Линия плавного изменения громкости"
  }
}
